import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type StatusPillVariant = 'success' | 'warning' | 'error' | 'neutral';

/**
 * Table-status values used across the apps map onto pill variants so the
 * pill can be dropped in wherever a `{ displayName, value }` status cell
 * already exists.
 */
const VALUE_TO_VARIANT: Record<string, StatusPillVariant> = {
  success: 'success',
  active: 'success',
  warning: 'warning',
  pending: 'warning',
  error: 'error',
  inactive: 'error',
  neutral: 'neutral',
};

const VARIANT_CLASSES: Record<StatusPillVariant, string> = {
  success: 'bg-[#E3FDF0] text-[#0FB967]',
  warning: 'bg-[#FEF4E6] text-[#F79009]',
  error: 'bg-[#FEECEB] text-[#D92D20]',
  neutral: 'bg-[#F0F0F0] text-[#6B6B6A]',
};

@Component({
  selector: 'lib-status-pill',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      class="px-3 py-1 rounded-full text-xs font-medium capitalize inline-block {{
        classes()
      }}"
    >
      {{ label() }}
    </span>
  `,
})
export class StatusPill {
  label = input.required<string>();
  /** Accepts a pill variant or a table status value ('active' | 'pending' | 'inactive'). */
  variant = input<string>('neutral');

  classes = computed(
    () =>
      VARIANT_CLASSES[VALUE_TO_VARIANT[this.variant().toLowerCase()] ?? 'neutral'],
  );
}
